module.exports = __webpack_public_path__ + "img/wet.7f5b3012.png";